/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZD0iTTEzLjIgMTAuMjFIMy4yMVY1LjkyTDQuOTIgNC4yMUgxMi4yVjYuMjFIMTAuMjFMMTIuNyA4LjcxTDE1LjIxIDYuMjFIMTMuMlYzLjIxSDQuOTJMMi43MSAxTDAgMy43MUwyLjIxIDUuOTJWMTUuNzFIMy4yMVYxMS4yMUgxMi4yVjEzLjIxSDEwLjIxTDEyLjcgMTUuNzFMMTUuMjEgMTMuMjFIMTMuMlYxMC4yMVpNMi43MSAyLjQyTDQgMy43MUwyLjcxIDVMMS40MiAzLjcxTDIuNzEgMi40MloiIGZpbGw9ImluaGVyaXQiLz4=";